import * as R from 'ramda'
import * as Dictionary from './Dictionary'

export interface M {
    readonly path: string
    readonly parameters: Dictionary.Dictionary<string>
}

export function fromHash(hash: string): M {
    const
        hashValue = hash.slice(1),
        questionMarkPosition = hashValue.indexOf('?')
    if (questionMarkPosition !== -1) {
        return {
            path: hashValue.slice(0, questionMarkPosition),
            parameters:
                Dictionary.fromList(
                    R.map(
                        (parameterString): [string, string] => {
                            const [key, value] = parameterString.split('=')
                            return [
                                decodeURIComponent(key),
                                decodeURIComponent(value),
                            ]
                        },
                        hashValue.slice(questionMarkPosition + 1).split('&'),
                    ),
                ),
        }

    } else {
        return {
            path: hashValue,
            parameters: {}
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Data/Location.ts